<template>
    <b-modal size="lg" ref="modal" @close="close" centered no-close-on-backdrop>
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center w-100"> 
          <div></div>
          <h5 class="text-centerfont-weight-bolder m-0">Monthly News Letter Preview</h5>
          
          <b-button
            size="sm"
            variant="none"
            class="btn-icon btn-circle btn-hover-dark"
            title="Close"
            @click="close"
            v-b-tooltip.hover
            >
            <i class="material-icons icon-xl">close</i>
          </b-button>
        </div>
      </template>
  
      <template #default v-if="loading">
        <div class="d-flex align-items-center justify-content-center">
          Loading...
        </div>
      </template>
      <template #default v-else>
        <div
              class="alert text-center font-weight-bolder"
              :class="variants"
              v-if="error && error.length"
              >
              {{ error }}
            </div>
            <div
              class="alert text-center font-weight-bolder"
              :class="success"
              v-else-if="message && message.length >0"
              >
              {{ message }}
            </div>
            <div v-else>
              <newsletterPreviewer
               :newsletterData="newsletterData[0]" 
               :isMobileDevice="isMobileDevice"
            >  
            </newsletterPreviewer>
            </div>
      </template>
  
      <template #modal-footer="{ close }">
        <div class="d-flex justify-content-between mx-auto">
          <b-button
            class="btn-pill font-weight-bold mr-2"
            variant="dark"
            :disabled="disabled"
            @click="close"
          >
            <span>Close</span>
          </b-button>
          <b-button
            class="btn-pill font-weight-bold"
            variant="dark"
            :disabled="disabled"
            @click="()  => {sendNewsletter();}"
          >
            <span>Send Email</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </template>
  
  <script>
  import NewsletterService from "@/services/newsletter.service";
  import newsletterPreviewer from "@/components/newsletterPreviewer.vue";
  import { formatErrorMessage } from "@/utils/random_utils";
  
  export default {
    name: "newsletter-preview",
    components:{newsletterPreviewer},
    created(){
        let regexp = /android|iphone|kindle|ipad/i; 
        this.isMobileDevice = regexp.test(navigator.userAgent); 
        if(document.documentElement.clientWidth){
            this.isMobileDevice=true;
        }
    },
    methods: {
      previewNewsLetter(){
        this.loading = true;
        NewsletterService.get(this.companyId)
          .then(async ({ data }) => {
            this.newsletterData = data; 
          })
          .catch(({ message }) => {
            this.error = formatErrorMessage(message);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      open(businessId) {
        this.error = null;
        this.loading = false;
        this.companyId = businessId;
        this.$refs["modal"].show();
        this.previewNewsLetter();
        },
        close(){
            this.$refs['modal'].hide()
        },
      sendNewsletter() {
        this.loading = true;
        this.message =null;
        this.error=null;
        NewsletterService.post(this.newsletterData)
          .then(async ({ data }) => {
            this.message = data.message;
            setTimeout(() => {
                this.close();
                this.message = null;
            }, 1000);
          })
          .catch(({ message }) => {
            this.error = formatErrorMessage(message);
          })
          .finally(() => {
            this.loading = false;
          });
        }
    },
    computed: {
      disabled() {
        return this.loading;
      },
      variants() {
        return {
          show: this.error,
          "alert-light-danger": this.error,
        };
      },
      success(){
        return {
          show: this.message,
          "alert-light-success": this.message,
        };
      }
    },
    watch: {
    },
    data() {
      return {
        error: null,
        loading: false,
        newsletterData:null,
        companyId:null,
        message:null,
        isMobileDevice:false,
      };
    },
  };
  </script>
  